import { CheckPicker as CheckPickerLegacy } from './CheckPicker'
import {
  Container as CheckPickerContainer,
  CustomTitle as CheckPickerCustomTitle,
} from './CheckPicker.styles'
import { CheckPicker as CheckPickerNew } from './CheckPickerNew'

export { CheckPickerContainer, CheckPickerCustomTitle }
export * from './CheckPicker.types'
export { checkPickerSearchBy } from './CheckPicker.utils'
export * as CheckPickerStyles from './CheckPickerNew.styles'

const CheckPicker = {
  Small: CheckPickerLegacy.Small,
  Default: CheckPickerLegacy.Default,
  SmallNew: CheckPickerNew.Small,
  DefaultNew: CheckPickerNew.Default,
}

export { CheckPicker }
